import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import ToggleButtonGroup from "../../../sharedComponents/toggleButtonGroup/toggleButtonGroup";
import { CalculationService } from "../../../../services/services/calculationService";

interface PartOfFarmProps {
  calculateStore?: CalculateStore;
  calculationService?: CalculationService;
}

export function PartOfFarm(props: PartOfFarmProps) {
  const calculateStore = props.calculateStore!;

  const question = {
    text: "Czy nieruchomość wchodzi w skład gospodarstwa rolnego?",
    setValue(newValue: string) {
      const partOfFarmSelected = newValue === "yes" ? true : (newValue === "no" ? false : undefined);
      calculateStore.setPartOfFarm(partOfFarmSelected);
      props.calculationService!.setRisksNetworkForAllPackages();
    },
    infoMessage: "Pamiętaj o ubezpieczeniu budynków niemieszkalnych wchodzących " +
      "w skład gospodarstwa rolnego w ramach ubezpieczenia obowiązkowego: Pakiet Bezpieczny Rolnik w TUZ"
  };

  return (
    <div className="additional-questions-section part-of-farm">
      <ToggleButtonGroup
        question={question.text}
        errorMessage={calculateStore.additionalQuestions.partOfFarm.errorMessage}
        options={[
          {
            value: "yes",
            label: "tak"
          },
          {
            value: "no",
            label: "nie"
          }
        ]}
        value={setToggleButtonValue()}
        onChange={(newValue: string) => { question.setValue(newValue); validate(); }}
        infoMessage={calculateStore.additionalQuestions.partOfFarm.value ? question.infoMessage : null}
      />
    </div>
  );

  function setToggleButtonValue() {
    const partOfFarm = calculateStore.additionalQuestions.partOfFarm.value;
    if (partOfFarm === undefined) {
      return undefined;
    }
    return partOfFarm ? "yes" : "no";
  }

  function validate() {
    calculateStore.additionalQuestions.partOfFarm.validatePartOfFarm();
  }
}

export default inject("calculateStore", "calculationService")(observer(PartOfFarm));
